import React from 'react'

import ErrorNotice from 'shared/components/common/error_notice'

import {
  PaymentIntentFailure,
  PaymentIntentFailureReason,
  usePayment
} from 'public/components/online_ordering/PaymentContext'

import { t } from 'src/translations'

type Props = {
  failure: PaymentIntentFailure
  canPayAtRestaurant?: boolean
}

/**
 * Shown in place of the card form when the payment intent couldn't be created —
 * without it the form's loading state never resolves and the guest is left with a
 * shimmer and no explanation.
 */
const PaymentIntentError = ({ failure, canPayAtRestaurant }: Props) => {
  const { retryPaymentIntent } = usePayment()

  const message = {
    [PaymentIntentFailureReason.ReCaptchaBlocked]: t(
      'payment-intent-error.recaptcha-blocked'
    ),
    [PaymentIntentFailureReason.ReCaptchaUnverified]: t(
      'payment-intent-error.recaptcha-unverified'
    ),
    [PaymentIntentFailureReason.Unknown]: t('payment-intent-error.unknown')
  }[failure.reason]

  return (
    <div className='paymentIntentError' role='alert'>
      <ErrorNotice>
        {message}
        {canPayAtRestaurant &&
          ` ${t('payment-intent-error.pay-at-restaurant-alternative')}`}
      </ErrorNotice>
      {failure.canRetry && (
        <button
          type='button'
          className='paymentIntentErrorRetry'
          onClick={() => void retryPaymentIntent()}
        >
          {t('payment-intent-error.try-again')}
        </button>
      )}
    </div>
  )
}

export default PaymentIntentError
